/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.21/esri/copyright.txt for details.
*/
import{Milliseconds as e}from"../../../core/time.js";const o=25,r=e(1e3/o),t=20,m=e(1e3/t);export{o as DESIRED_ANIMATION_FPS,r as DESIRED_ANIMATION_MS,t as DESIRED_DRAPED_ANIMATION_FPS,m as DESIRED_DRAPED_ANIMATION_MS};
